module.exports = __webpack_public_path__ + "static/media/dcbXalmaden.d9df0499.png";